<template>
  <div class="safedig-forgot-page" v-loading.fullscreen.lock="loading">
    <SafeDigHeader />
    <div class="safedig-forgot-main">
      <div class="safedig-forgot-content">
        <div class="safedig-forgot-card">
        <div class="safedig-forgot-card-header">{{ $t('forgotPassword.accountLookup') }}</div>
        <div class="safedig-forgot-card-body">
          <p class="safedig-forgot-instruction">{{ $t('forgotPassword.instruction') }}</p>
          <p class="safedig-forgot-help">
            {{ $t('forgotPassword.noEmailOnFile') }}
            <a href="mailto:safedigindiana@urc.in.gov" class="safedig-phone-link">safedigindiana@urc.in.gov</a>
            {{ $t('forgotPassword.forAssistance') }}
          </p>
          <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <form role="form" @submit.prevent="handleSubmit(onSubmit)" class="safedig-forgot-form">
              <div class="safedig-forgot-row">
                <div class="safedig-form-group safedig-email-group">
                  <label class="safedig-label">{{ $t('forgotPassword.email') }}</label>
                  <base-input
                    alternative
                    class="safedig-input-wrap"
                    name="Email"
                    :rules="{ required: true }"
                    type="email"
                    v-model="form.email"
                  />
                </div>
                <div class="safedig-send-wrap">
                  <base-button native-type="submit" class="safedig-send-btn">
                    {{ $t('forgotPassword.send') }}
                  </base-button>
                </div>
              </div>
              <p class="safedig-error" v-if="errors.invalid">{{ errors.invalid }}</p>
            </form>
          </validation-observer>
          <div class="safedig-forgot-links">
            <p class="safedig-report-issue">
              <a @click.prevent="showModal()" class="safedig-link" style="cursor: pointer;">
                Report an Issue?
              </a>
            </p>
          </div>
        </div>
        </div>
      </div>
    </div>
    <modal :show.sync="showReportModal" class="">
      <h3 slot="header" class="title title-up text-primary">
        Report an Issue or Share Feedback
      </h3>
      <small>
        <strong>
          If you've encountered a problem or have suggestions to improve your experience, please let us know. Your input helps us serve you better.
        </strong>
      </small>
      <div class="row mt-2">
        <div class="col-md-12">
          <!-- Name Input -->
          <div class="form-group">
            <label>Name</label>
            <input
              type="text"
              v-model="account.name"
              placeholder="Name"
              class="form-control"
            />
          </div>

          <!-- Email Input -->
          <div class="form-group">
            <label>Email</label>
            <input
              type="email"
              v-model="account.email"
              placeholder="Email"
              class="form-control"
            />
          </div>

          <base-input label="Select Issue">
            <el-select class="select-primary" v-model="account.issue" placeholder="Select Issue">
              <el-option class="select-primary" v-for="item in feedbackCategories" :key="item.key" :label="item.value"
                :value="item.value">
              </el-option>
            </el-select>
          </base-input>

          <div class="form-group">
            <label>Comments</label>
            <textarea
              v-model="account.comments"
              placeholder="Enter your comments here..."
              class="form-control"
              rows="4"
            ></textarea>
          </div>
          <div class="text-right">
            <base-button
              class="greybtn"
              outline
              @click="hideModal()"
            >
              Close
            </base-button>
            <base-button
              type="primary"
              @click="submitData()"
            >
              Submit
            </base-button>
        </div>
      </div>
        </div>

    </modal>
    <div class="siteFooter footerOffWhite safedigFooter safedigForgotFooter">
      <div class="safedigCustomFooter">
        <div>
          <img src="../../../assets/safe-dig/safedig_logo_grayscale-01.png" class="safedigindiana811Logo"
            alt="Safe Dig Indiana" />
        </div>
        <p class="copyright">
          {{ $t('footer.copyright', { year }) }}<br>
          {{ $t('footer.allRightsReserved') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { Option, Select } from 'element-ui';
import SafeDigHeader from '@/components/safe-dig/Header.vue';

export default {
  name: 'SafeDigForgotPassword',
  components: {
    SafeDigHeader,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      loading: false,
      showReportModal: false,
      feedbackCategories: [
        { key: 'general_feedback', value: 'General Feedback' },
        { key: 'logging_in', value: 'Logging In' },
        { key: 'course_taking', value: 'Course Taking' },
        { key: 'course_assigning', value: 'Course Assigning' },
        { key: 'user_creation_updating', value: 'User Creation/Updating' },
        { key: 'location_creation_updating', value: 'Location Creation/Updating' },
        { key: 'platform_not_working', value: 'Platform Not Working' },
        { key: 'other', value: 'Other' }
      ],
      account: {
        name: '',
        email: '',
        issue: '',
        comments: ''
      },
      form: {
        email: ''
      },
      errors: {
        invalid: ''
      },
      year: new Date().getFullYear()
    };
  },
  methods: {
    showModal() {
      this.showReportModal = true;
    },
    hideModal() {
      this.showReportModal = false;
    },
    submitData() {
      this.$http
        .post('support', {
          name: this.account.name,
          email: this.account.email,
          issue: this.account.issue,
          comments: this.account.comments
        })
        .then((resp) => {
          Swal.fire({
            icon: 'success',
            title: 'Message Sent',
            text: resp.data.message || 'Your support request was sent successfully!'
          });
          this.account = {
            name: '',
            email: '',
            issue: '',
            comments: ''
          };
          this.hideModal();
        })
        .catch((error) => {
          let errorText = 'Something went wrong. Please try again.';

          // Laravel validation error (422)
          if (error.response && error.response.status === 422) {
            if (typeof error.response.data.errors === 'object') {
              const messages = Object.values(error.response.data.errors)
                .flat()
                .join('\n');
              errorText = messages;
            } else if (error.response.data.message) {
              errorText = error.response.data.message;
            }
          }

          // Laravel general error
          else if (error.response && error.response.data && error.response.data.message) {
            errorText = error.response.data.message;
          }

          Swal.fire({
            icon: 'error',
            title: 'Submission Failed',
            text: errorText
          });
        });
    },
    onSubmit() {
      this.errors.invalid = '';
      this.loading = true;
      this.$http
        .post('user/resetLink', {
          user_name: this.form.email
        })
        .then((resp) => {
          Swal.fire({
            html: resp.data.message,
            icon: 'success',
            confirmButtonClass: 'btn btn-success btn-fill'
          });
        })
        .catch((error) => {
          const message = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Something went wrong. Please try again.';
          this.errors.invalid = message;
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style scoped>
.safedig-forgot-page {
  font-family:'apple-system', BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.safedig-forgot-main {
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 32px 16px 48px;
}

.safedig-forgot-content {
  width: 100%;
  max-width: 530px;
}

.safedig-forgot-card {
  width: 100%;
  max-width: 530px;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  border: 1px solid #b8c2cc;
  border-radius: 4px;
  overflow: hidden;
  text-align: left;
  max-height: fit-content;
}

.safedig-forgot-card-header {
  background: #3e7799;
  color: #fff;
  padding: 10px 15px;
  font-size: 18px;
  font-weight: 700;
}

.safedig-forgot-card-body {
  padding: 10px 15px;
}

.safedig-forgot-instruction {
  margin: 0 0 16px;
  font-size: 16px;
  color:  #3d4852;
  line-height: 1.5;
}

.safedig-forgot-help {
  margin: 0 0 16px;
  font-size: 16px;
  color: #3d4852;
  line-height: 1.5;
}

.safedig-phone-link {
  color: #1e3a5f;
  font-weight: 500;
  text-decoration: none;
}

.safedig-phone-link:hover {
  text-decoration: underline;
}

.safedig-forgot-form {
  margin: 0;
}

.safedig-forgot-row {
  display: flex;
 flex-direction: column;
}

.safedig-form-group {
  margin-bottom: 0;
}

.safedig-email-group {
  flex: 1;
  min-width: 200px;
}

.safedig-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  letter-spacing: 0.02em;
  margin-bottom: 6px;
}

.safedig-forgot-page >>> .input-group-alternative {
  box-shadow: none;
}

.safedig-input-wrap >>> .form-control {
  height: 44px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background: #fff;
  padding: 12px 16px;
}

.safedig-send-wrap {
  flex-shrink: 0;
  align-self: flex-end;
}

.safedig-send-btn {
  height: 44px;
  padding: 0 24px;
  font-size: 16px;
  font-weight: 600;
  background: #9c3c21 !important;
  border: none !important;
  border-radius: 4px !important;
  color: #fff !important;
}

.safedig-send-btn:hover {
  background: #85341c !important;
  color: #fff !important;
}

.safedig-error {
  color: #c00;
  font-size: 14px;
  margin: 12px 0 0;
}

.siteFooter {
  width: 100%;
}

.safedigFooter {
  background: #e8e8e8;
}

.safedigForgotFooter .safedigCustomFooter {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.safedigindiana811Logo {
  height: 60px;
  width: auto;
}

.copyright {
  margin: 0;
  color: #6b6b6b;
  font-size: 14px;
  line-height: 1.5;
}

.safedig-forgot-links {
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
  text-align: left;
}

.safedig-link {
  color: #1e3a5f;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
}

.safedig-link:hover {
  text-decoration: underline;
}

.safedig-report-issue {
  margin: 0;
  font-size: 0.95rem;
  color: #555;
}

@media (max-width: 480px) {
  .safedig-forgot-row {
    flex-direction: column;
    align-items: stretch;
  }

  .safedig-send-wrap {
    width: 100%;
  }

  .safedig-send-btn {
    width: 100%;
  }
}
</style>
